import Api from "../../../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        actionsEprofileAllergia: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új bejegyzés',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newEprofileAllergiaRow'
            }
        ],
        formActionsEprofileAllergia: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToEprofileAllergiaGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetEprofileAllergiaForm'
            }
        ],
        rowActionsEprofileAllergia: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyEprofileAllergiaRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteEprofileAllergiaRow'
            }
        ],
        searchFields: [
            {
                name: "betegIdTipus",
                label: "Páciens azonosítás típus",
                formSize: 4,
                formType: "select",
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getIdTypeList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "betegIdErtek",
                label: "Páciens azonosító",
                formSize: 4,
                formType: "text"
            },
            {
                name: "breakGlass",
                label: "Sürgősségi adatlekérés",
                formType: "checkbox",
                formSize: 4
            },
            {
                name: "breakGlassOk",
                label: "Sürgősségi adatlekérés oka",
                formType: "text",
                formSize: 4
            }
        ],
        headerFieldsEprofileAllergia: [
            {
                name: "betegIdErtek",
                label: "Beteg ID érték",
                filter: {
                    type: "simple",
                },
                visibility: false
            },
            {
                name: "betegIdTipus",
                label: "Beteg ID típus",
                filter: {
                    type: "simple",
                },
                visibility: false
            },
            {
                name: "hitelesito",
                label: "Hitelesítő",
                description: "ENKK nyilvántartási szám, pl: 12345",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formRequired: true,
                formType: "text",
                formSize: 6,
                formVisible: true
            },
            {
                name: "megfigyelo",
                label: "Megfigyelő",
                description: "ENKK nyilvántartási szám, pl: 12345",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formRequired: true,
                formType: "text",
                formSize: 6,
                formVisible: true
            },
            {
                name: "leiras",
                label: "Leírás",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formRequired: true,
                formType: "textarea",
                formSize: 12,
                formVisible: true
            },
            {
                name: "bizonyossag",
                label: "Bizonyosság",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formRequired: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getBizonyossagList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                formVisible: true
            },
            {
                name: "onrendelkezesiKategoria",
                label: "Önrendelkezési kategória",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formRequired: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getOnrendelkezesList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 6,
                formVisible: true
            },
            {
                name: "eesztid",
                label: "EESZT ID",
                filter: {
                    type: "simple",
                },
                visibility: false
            },
            {
                name: "verzio",
                label: "Verzió",
                filter: {
                    type: "simple",
                },
                visibility: false
            },
            {
                name: "agensKod",
                label: "Kiváltó tényező típus",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formRequired: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getKivaltoTenyezoTipusList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                formVisible: true
            },

            {
                name: "agensELELMISZER",
                agensId: "ELELMISZER",
                label: "Kiváltó tényező",
                filter: {
                    type: "simple",
                },
                sort: true,
                formRequired: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getAgensElelmiszerList,
                    formatText: function(val){
                        return val.text;
                    },
                    formatOption: function(val){
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                formVisible: false,
                visibility: false
            },
            {
                name: "agensKORNYEZETI_TENYEZO",
                agensId: "KORNYEZETI_TENYEZO",
                label: "Kiváltó tényező",
                filter: {
                    type: "simple",
                },
                sort: true,
                formRequired: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getAgensKornyezetiTenyezoList,
                    formatText: function(val){
                        return val.text;
                    },
                    formatOption: function(val){
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                formVisible: false,
                visibility: false
            },
            {
                name: "agensOGYEI",
                agensId: "OGYEI",
                label: "Kiváltó tényező",
                filter: {
                    type: "simple",
                },
                sort: true,
                formRequired: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getDrugByFilter,
                    formatText: function(val){
                        return val.text;
                    },
                    formatOption: function(val){
                        return val.text;
                    },
                    minimumInputLength: 3,
                    searchOnServer: true,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                formVisible: false,
                visibility: false
            },
            {
                name: "agensEGYEB",
                agensId: "EGYEB",
                label: "Kiváltó tényező",
                filter: {
                    type: "simple",
                },
                sort: true,
                formRequired: true,
                formType: "text",
                formSize: 3,
                formVisible: true,
                visibility: false
            },

            {
                name: "agens",
                label: "Kiváltó tényező",
                filter: {
                    type: "simple",
                },
                sort: true,
                formRequired: true,
                formType: "text",
                formSize: 3,
                formVisible: false
            },

            {
                name: "agensString",
                label: "Ágens",
                filter: {
                    type: "simple",
                },
                visibility: false
            },
            {
                name: "agensTipus",
                label: "Ágens típusa",
                filter: {
                    type: "simple",
                },
                sort: true,
                formRequired: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getAgensTipusList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                formVisible: true
            },
            {
                name: "reakcioKod",
                label: "Allergia leírása",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formRequired: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getReakcioKodList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                formVisible: true
            },
            {
                name: "reakcio",
                label: "Reakció",
                filter: {
                    type: "simple",
                },
                sort: true,
                formVisible: false
            },
            {
                name: "megfigyelesIdopontja",
                label: "Megfigyelés időpontja",
                filter: {
                    type: "simple",
                },
                sort: true,
                formRequired: true,
                formType: "date",
                formSize: 3,
                formVisible: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ]
    }
}
